import { createFileRoute } from '@tanstack/react-router'
import { CoveragePage } from '@bloo-team/product-vantage'
import type { CoverageSearch } from '@bloo-team/product-vantage'

/**
 * Composer shim (S5.0, docs/modularization.md §Route mounting): route
 * infrastructure stays in the app's tree; the surface lives in
 * @bloo-team/product-vantage. `?adv=` opens an adversary profile, `?stream=`
 * filters the matrix lens, `?silent=` narrows to silent techniques.
 */
function CoverageRoute() {
  const { clusterId, scopeId } = Route.useParams()
  const search = Route.useSearch()
  return <CoveragePage clusterId={clusterId} scopeId={scopeId} search={search} />
}

export const Route = createFileRoute('/$clusterId/$scopeId/vantage/coverage')({
  validateSearch: (search: Record<string, unknown>): CoverageSearch => ({
    adv: typeof search.adv === 'string' && search.adv ? search.adv : undefined,
    stream: typeof search.stream === 'string' && search.stream ? search.stream : undefined,
    silent: search.silent === true || search.silent === 'true' ? true : undefined,
  }),
  component: CoverageRoute,
})
